import React from 'react';
import { DollarSign, MapPin, TrendingUp, Clock } from 'lucide-react';
export function WhyLaundromatSection() {
  const stats = [{
    icon: DollarSign,
    value: '$5B+',
    label: 'Annual Market Size',
    description: 'The U.S. laundromat industry serves millions of customers daily'
  }, {
    icon: MapPin,
    value: '35,000+',
    label: 'Locations Nationwide',
    description: 'Highly fragmented with 95% independently owned'
  }, {
    icon: TrendingUp,
    value: 'Resilient',
    label: 'Recession-Resistant',
    description: 'Essential service with consistent demand across economic cycles'
  }, {
    icon: Clock,
    value: 'Untapped',
    label: 'Modernization Opportunity',
    description: 'Industry ripe for operational improvements and technology integration'
  }];
  return <section className="py-16 sm:py-20 lg:py-24 bg-[#0b1a1a]" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-12 sm:mb-16" data-id="element-248">
          <h2 className="text-xs sm:text-sm font-semibold text-[#4fd1c5] tracking-widest uppercase mb-3 sm:mb-4" data-id="element-249">
            Market Opportunity
          </h2>
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 px-4" data-id="element-250">
            Why Laundromats?
          </h3>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed px-4" data-id="element-251">
            The laundromat industry is a massive, essential service sector
            that's remained largely unchanged for decades. We see an opportunity
            to bring modern management practices to this fragmented market.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-252">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="text-center px-4" data-id="element-253">
                <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#4fd1c5]/10 mb-5 sm:mb-6" data-id="element-254">
                  <Icon className="h-7 w-7 sm:h-8 sm:w-8 text-[#4fd1c5]" data-id="element-255" />
                </div>
                <div className="text-3xl sm:text-4xl font-bold text-white mb-2" data-id="element-256">
                  {stat.value}
                </div>
                <div className="text-base sm:text-lg font-semibold text-[#4fd1c5] mb-3" data-id="element-257">
                  {stat.label}
                </div>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-258">
                  {stat.description}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-12 sm:mt-16 bg-[#0f2424] border border-gray-800 rounded-2xl p-6 sm:p-8 md:p-12" data-id="element-259">
          <div className="max-w-4xl mx-auto text-center" data-id="element-260">
            <h4 className="text-xl sm:text-2xl font-bold text-white mb-4" data-id="element-261">
              The Laundry Investors Difference
            </h4>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-6" data-id="element-262">
              While the industry has remained fragmented, we're building a
              platform that combines the best of local ownership with the
              efficiency and consistency of professional management. Our
              approach preserves the neighborhood feel customers love while
              delivering the reliability and quality they deserve.
            </p>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-xs sm:text-sm" data-id="element-263">
              <span className="px-3 sm:px-4 py-2 bg-[#4fd1c5]/10 text-[#4fd1c5] rounded-full border border-[#4fd1c5]/20" data-id="element-264">
                Standardized Operations
              </span>
              <span className="px-3 sm:px-4 py-2 bg-[#4fd1c5]/10 text-[#4fd1c5] rounded-full border border-[#4fd1c5]/20" data-id="element-265">
                Technology Integration
              </span>
              <span className="px-3 sm:px-4 py-2 bg-[#4fd1c5]/10 text-[#4fd1c5] rounded-full border border-[#4fd1c5]/20" data-id="element-266">
                Preventive Maintenance
              </span>
              <span className="px-3 sm:px-4 py-2 bg-[#4fd1c5]/10 text-[#4fd1c5] rounded-full border border-[#4fd1c5]/20" data-id="element-267">
                Customer Experience Focus
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}